/**
 * Zorgt voor het kunnen ontvangen van de pupils
 * id = group_index
 *
 * @history
 * 23 november 2022
 * Basis implementatie
 *
 */
import React from 'react';
import {useDroppable} from '@dnd-kit/core';

export function DroppablePupils(props) {
    const {isOver, setNodeRef} = useDroppable({
        id: props.id,
        data:
            {
                group_index:props.group_index,
                occupied: props.occupied
            }
    });
    const style = {
       // color: isOver ? 'green' : undefined,
        width:"75px",
        height:"75px",
        "margin-left":"5px",
        "margin-bottom":"2px",
        float:"left",
        "background-color":"#fff",


    };


    return (
        <div ref={setNodeRef} style={style}>
            {props.children}
        </div>
    );
}
